module.exports = __webpack_public_path__ + "img/feature_buy_th.65a55638.png";